<template>
  <a-modal
    v-model="modal.visible"
    :width="800"
    :title="`确认开票`"
    okText="确认开票"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <div>
      <a-form :form="modal.form" labelAlign="left" class="flex-form no-gap">
        <div class="grid grid-cols-2">
          <a-form-item>
            <template v-slot:label>发票类型</template>
            <span>{{ translateType$t(modal.data.billType, 'billType') }}</span>
          </a-form-item>
          <a-form-item>
            <template v-slot:label>发票性质</template>
            <span>{{ translateType$t(modal.data.billMode, 'billMode') }}</span>
          </a-form-item>
          <a-form-item label="开票金额">
            <span>{{ modal.data.billAmount }}</span>
          </a-form-item>
          <a-form-item label="发票抬头">
            <span>{{ modal.data.billTitle }}</span>
          </a-form-item>
          <template v-if="modal.data.titleType == 2">
            <a-form-item>
              <template v-slot:label>
                <span v-html="'税&emsp;&emsp;号'"></span>
              </template>
              <span>{{ modal.data.taxNo }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'地&emsp;&emsp;址'"></span>
              </template>
              <span>{{ modal.data.address }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'电&emsp;&emsp;话'"></span>
              </template>
              <span>{{ modal.data.tel }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'开&ensp;户&ensp;行'"></span>
              </template>
              <span>{{ modal.data.bankName }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'账&emsp;&emsp;户'"></span>
              </template>
              <span>{{ modal.data.bankAccount }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'收票邮箱'"></span>
              </template>
              <span>{{ modal.data.email }}</span>
            </a-form-item>
            <a-form-item>
              <template v-slot:label>
                <span v-html="'收票联系人'"></span>
              </template>
              <span>{{ modal.data.contact }}</span>
            </a-form-item>
          </template>
        </div>
        <a-form-item class="block">
          <template v-slot:label>
            <span v-html="'发票上传'"></span>
          </template>
          <PictureCardUpload
            v-decorator="['billUrl', { rules: [{ required: true, message: '请上传电子发票' }] }]"
            preview
            :itemWidth="200"
            :itemHeight="150"
            tips="点击上传电子发票"
          />
        </a-form-item>
        <a-form-item class="block">
          <template v-slot:label>
            <span v-html="'备注'"></span>
          </template>
          <a-textarea v-decorator="['remark']" :rows="4"></a-textarea>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload'

export default {
  mixins: [toolMixin],
  data() {
    return {
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '选择国家',
        data: {},
      },
    }
  },
  components: {
    PictureCardUpload,
  },
  computed: {
    typesMap() {
      return {
        billType: [{ value: 1, label: '增值税普通电子发票' }],
        billMode: [{ value: 1, label: '电子发票' }],
      }
    },
  },
  methods: {
    async start(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.data = { ...row }
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.put('/order-web-api/admin/order/bill/submit', {
              id: Number(this.modal.data.billId),
              ...params,
            })
            this.$emit('end', 'ok')
          } catch (e) {}
        }
      })
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
